module.exports = __webpack_public_path__ + "media/images/design/images/btn_blog-bd42d4d84068182bdafb8680eea28265.png";